import JSONPTransport from './jsonptransport';
import XHRPollingTransport from './xhrpollingtransport';
import XHRStreamingTransport from './xhrstreamingtransport';

export default [JSONPTransport, XHRPollingTransport, XHRStreamingTransport];
